export default "__VITE_ASSET__BrPMeE1G__"